import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryPublic } from "@/lib/rtk-query-config";
import {
  EcommerceProdutoDto,
  CheckoutRequestDto,
  CheckoutResponseDto,
  MercadoPagoConfigDto,
  ProcessPaymentRequestDto,
} from "@/interfaces/ecommerce.interface";

interface GetProdutosArgs {
  loginSlug: string;
  eventoId?: number;
}

interface GetProdutoDetalheArgs {
  loginSlug: string;
  id: number;
}

interface GetMercadoPagoConfigArgs {
  loginSlug: string;
  valorTotal: number;
  eventoId?: number;
}

interface CriarCheckoutArgs {
  loginSlug: string;
  body: CheckoutRequestDto;
}

interface ProcessPaymentArgs {
  loginSlug: string;
  body: ProcessPaymentRequestDto;
}

export const ecommerceApi = createApi({
  reducerPath: "ecommerceAPI",
  baseQuery: baseQueryPublic,
  tagTypes: ["EcommerceProdutos", "EcommerceConfig"],
  endpoints: (build) => ({
    getProdutos: build.query<
      EcommerceProdutoDto[] | { data: EcommerceProdutoDto[] },
      GetProdutosArgs
    >({
      query: ({ loginSlug, eventoId }) => {
        const params = eventoId ? { eventoId } : {};
        return {
          url: `ecommerce/${loginSlug}/produtos`,
          params,
        };
      },
      providesTags: ["EcommerceProdutos"],
    }),

    getProdutoDetalhe: build.query<
      EcommerceProdutoDto,
      GetProdutoDetalheArgs
    >({
      query: ({ loginSlug, id }) => ({
        url: `ecommerce/${loginSlug}/produtos/${id}`,
      }),
      providesTags: (_result, _error, { id }) => [
        { type: "EcommerceProdutos", id },
      ],
    }),

    getMercadoPagoConfig: build.query<
      MercadoPagoConfigDto,
      GetMercadoPagoConfigArgs
    >({
      query: ({ loginSlug, valorTotal, eventoId }) => {
        const params: Record<string, string | number> = {
          valorTotal,
        };
        if (eventoId) {
          params.eventoId = eventoId;
        }
        return {
          url: `ecommerce/${loginSlug}/mercado-pago/config`,
          params,
        };
      },
      providesTags: ["EcommerceConfig"],
    }),

    criarCheckout: build.mutation<
      CheckoutResponseDto,
      CriarCheckoutArgs
    >({
      query: ({ loginSlug, body }) => ({
        url: `ecommerce/${loginSlug}/checkout`,
        method: "POST",
        body,
      }),
    }),

    processPayment: build.mutation<
      {
        success: boolean;
        status?: string;
        paymentId?: string;
        statusDetail?: string | null;
        threeDsInfo?: { externalResourceUrl: string; creq: string } | null;
      },
      ProcessPaymentArgs
    >({
      query: ({ loginSlug, body }) => ({
        url: `ecommerce/${loginSlug}/checkout/process-payment`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetProdutosQuery,
  useGetProdutoDetalheQuery,
  useGetMercadoPagoConfigQuery,
  useCriarCheckoutMutation,
  useProcessPaymentMutation,
} = ecommerceApi;
